import { Head, router } from '@inertiajs/react'
import React, { useState } from 'react'
import BasketSummary from './Components/BasketSummary'
import Header from './Components/Header'
import MenuList from './Components/MenuList'
import { useBasket } from './hooks/useBasket'
import Layout from './Layout'

export default function Drinks({ account, menu_items, basket: initialBasket, basket_items, sitting, sitting_label, offer_full_menu, customer_notes: initialNotes, table_number, is_development }) {
  const { basket, addToBasket, removeFromBasket, updateQuantity, basketTotal, basketCount } = useBasket(initialBasket, menu_items, basket_items)
  const [customerNotes, setCustomerNotes] = useState(initialNotes || '')

  const handleCheckout = () => {
    // POST basket to update_basket, which will redirect to checkout
    // This follows the POST-Redirect-GET pattern
    router.post(`/${account.slug}/order/update-basket`, {
      basket: basket,
      customer_notes: customerNotes,
      next_page: 'checkout'
    })
  }

  return (
    <>
      <Head title={`Drinks Menu - ${account.name}`} />
      <Layout account={account}>
        <Header
        account={account}
        basketTotal={basketTotal}
        basketCount={basketCount}
        currentTab="drinks"
        basket={basket}
        basketItems={basket_items}
        menuItems={menu_items}
        onUpdateQuantity={updateQuantity}
        onCheckout={handleCheckout}
        isDevelopment={is_development}
        customerNotes={customerNotes}
        onNotesChange={setCustomerNotes}
      />

      <div className="pb-48">
        <MenuList
          items={menu_items}
          basket={basket}
          onAdd={addToBasket}
          onRemove={removeFromBasket}
          sitting={sitting}
          sittingLabel={sitting_label}
          offerFullMenu={offer_full_menu}
          startCollapsed={!table_number}
          emptyLabel="No drinks available for this time."
        />
      </div>

      <BasketSummary
        total={basketTotal}
        count={basketCount}
        onNext={handleCheckout}
        nextLabel="Checkout"
        phoneNumber={account.phone}
      />
      </Layout>
    </>
  )
}
